export default function getLevel(distance, maxDistance, maxLevel) {
  const distanceRatio = 1 - (Math.min(maxDistance, Math.max(0, distance)) / maxDistance);
  const scaledRatio = (Math.exp(distanceRatio) - 1) / (Math.E - 1);
  return Math.floor(scaledRatio * maxLevel);
}



// WEBPACK FOOTER //
// ./src/lib/getLevel.js